// @ts-nocheck
import type { ClientWorkflowSummaryBadge } from '../hooks/useClientWorkflowSummaryBadges';

/** Summary chips — right-aligned on page headers; label and value share one baseline. */
export function ClientWorkflowSummaryBadges({ badges }: { badges: ClientWorkflowSummaryBadge[] }) {
  if (!badges.length) return null;
  return (
    <div className="flex min-w-0 max-w-full flex-wrap items-center justify-end gap-2">
      {badges.map(({ label, value, valueClass }) => (
        <span
          key={label}
          className="inline-flex min-w-0 max-w-full items-baseline gap-1.5 rounded-md border border-gray-200/60 bg-white/80 px-3 py-1.5 text-xs font-medium text-gray-700 shadow-sm backdrop-blur-sm"
        >
          <span className="shrink-0 text-gray-500">{label}:</span>
          <span className={`min-w-0 truncate tabular-nums ${valueClass || ''}`} title={String(value)}>
            {value}
          </span>
        </span>
      ))}
    </div>
  );
}
